import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '../../../shared/services/shared.service';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';
import { PaymentCardModel } from './paymentcard.model';

@Component({
    selector: 'convfact-dialog-import-account-paymentcard',
    templateUrl: './paymentcard-dialog-importAccount.component.html',
    standalone: false
})
export class PaymentCardDialogImportAccount {

    dataImport: PaymentCardModel = this.data.dataImport;
    importing = false;
    error = '';

    constructor(
        public dialogRef: MatDialogRef<PaymentCardDialogImportAccount, boolean>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private notify: NotificationService,
        public sharedService: SharedService
    ) { }

    startImport() {
        if (this.importing) return;
        this.importing = true;
        this.error = '';
        this.dialogRef.disableClose = true;
        this.sharedService.importAccountsUpdate(this.dataImport, "PaymentCard")
            .then(() => {
                this.notify.ok('Asientos añadidos a la tarjeta existente');
                this.dialogRef.disableClose = false;
                this.dialogRef.close(true);
            })
            .catch(error => {
                this.importing = false;
                this.dialogRef.disableClose = false;
                this.error = (error && error.error && error.error.message) || 'No se pudieron añadir los asientos a la tarjeta';
            });
    }

    closeDialog() {
        if (this.importing) return;
        this.dialogRef.close(false);
    }
}
